import React from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: {
    value: string;
    label: string;
  }[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  id,
  className = '',
  ...props
}: SelectProps) {
  const selectId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className={`flex flex-col ${className}`} data-id="element-6">
      <label htmlFor={selectId} className="mb-2 text-xs font-medium tracking-widest text-gray-500 uppercase" data-id="element-7">
        {label}
      </label>
      <div className="relative" data-id="element-8">
        <select id={selectId} className={`w-full px-4 py-3 bg-transparent border ${error ? 'border-red-500' : 'border-gray-300'} focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-none appearance-none`} {...props} data-id="element-9">
          <option value="" disabled data-id="element-10">
            Select an option
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-11">
              {opt.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-4 pointer-events-none text-gray-500" data-id="element-12">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-13">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-14" />
          </svg>
        </div>
      </div>
      {error && <span className="mt-1 text-xs text-red-500" data-id="element-15">{error}</span>}
    </div>;
}